import { render, staticRenderFns } from "./BingMapLayer.vue?vue&type=template&id=54f6f888"
import script from "./BingMapLayer.vue?vue&type=script&lang=js"
export * from "./BingMapLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports